import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { ErrorDialogComponent } from '@awp/common';
import * as actions from './actions';

@Injectable()
export class ErrorEffects {

  constructor(
    private actions$: Actions<any>,
    private dialog: MatDialog) { }

  @Effect( {dispatch: false})
  errors$ = this.actions$.pipe(
    ofType(
      actions.ActionTypes.BIN_SEARCH_FAILURE,
      actions.ActionTypes.SELECT_CARD_TYPE_FAILURE
    ),
    tap(action => {
      const error = (<any> action).error;
      this.dialog.open(ErrorDialogComponent, {
        data: { error }
      });
    }));
}
